import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spacedTitleCase'
})
/**
 *Convert a string to spaced title case.
 * eg. testCase => Test case
 */
export class SpacedTitleCasePipe implements PipeTransform {

  transform(value: string): string {
    let newValue = [];
    let chars = value ? value.toString().split('') : [];
    for (let char = 0; char < chars.length; char++) {
      if (char === 0) {
        newValue.push(chars[char].toUpperCase());
      } else {
        if (chars[char] === '-' || chars[char] === '_') {
          newValue.push(' ');
        } else if (chars[char].charCodeAt(0) >= 65 &&
          chars[char].charCodeAt(0) <= 90) {
          newValue.push(' ');
          newValue.push(chars[char].toLowerCase());
        } else {
          newValue.push(chars[char]);
        }
      }
    }
    let label = '';
    let exceptionalWord = ['to', 'of', 'for', 'or'];
    newValue.join('').split(' ').forEach((word, index) => {
      if (index === 0) {
        label = word.charAt(0).toUpperCase() + word.substr(1, word.length - 1);
      } else {
        label += ' ';
        if (exceptionalWord.indexOf(word) > -1) {
          label += word.toLowerCase();
        } else {
          label += word.charAt(0).toUpperCase() + word.substr(1, word.length - 1);
        }
      }
    });

    return label;
  }
}
